$(function() {

$('.js-slider-products .slider__slides').slick({
    infinite: false,
    slidesToShow: 2.8,
    swipeToSlide: true,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $('.js-slider-products .js-arrow-prev'),
    nextArrow: $('.js-slider-products .js-arrow-next'),
    responsive: [
    {
        breakpoint: 767,
        settings: {
            arrows: false,
            slidesToShow: 1.17,
        }
    },
  ]
});

});